import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';

import {AccountNumberPipe, ReversePipe} from './pipes';
import {FillPipe} from './pipes/fill.pipe';
import {InjectorModule} from '../injector.module';
import {ColorContrastDirective} from './directives';
import { YesNoDialogComponent} from './shared-components';
import {MaterialModule} from '../material.module';

@NgModule({
  declarations: [
    YesNoDialogComponent,
    AccountNumberPipe,
    FillPipe,
    ReversePipe,
    ColorContrastDirective
  ],
  imports: [
    InjectorModule,
    MaterialModule,
  ],
  exports: [
    AccountNumberPipe,
    FillPipe,
    ReversePipe,
    ColorContrastDirective
  ],
  providers: [
    DatePipe
  ]
})
export class CoreModule { }
